import { gsap } from "../layout"

function appendWoocommerceNotice() {
    const noticeWrapper = document.querySelector('.woocommerce-notices-wrapper')
    const noticeContent = noticeWrapper.innerHTML
    const noticeWrapperAll = document.querySelectorAll('.woocommerce-notices-wrapper')

    noticeWrapperAll.forEach(nw => {
        if (noticeContent) {
            nw.innerHTML = noticeContent
        }
    });

    // console.log(noticeWrapper.innerHTML);
}

function changeOrderButtonText() {
    setTimeout(() => {
        const orderButton = document.querySelector('.wc-block-components-button__text')
        console.log(orderButton);
    
        if (!orderButton) return
    
        orderButton.textContent = 'Confirm Booking'
    }, 500);
} 

document.addEventListener('DOMContentLoaded', () => {
    appendWoocommerceNotice()
    changeOrderButtonText()
})